import LazyIframe from "components/common/iframe/lazyIframe";
import LayoutStep from "components/common/layout/layoutStep";
import Button from "components/ui/atoms/button/button";
import { titleTrainingDays } from "data/config";
import Link from "gatsby-link";
import React from "react";

import SEO from "../../components/SEO/SEO";

const Step52 = () => {
  return (
    <LayoutStep>
      <SEO
        title={`Manufacturing and Assembly | ${titleTrainingDays}`}
        description={"Technical video about this profesional field"}
        canonical={"training-days/step-5-2/"}
      />
      <div className="container step">
        <p className={"h1"} id={"title"}>
          {titleTrainingDays} - Step 5.2{" "}
        </p>
        <h1 className={"slideLeft"}>Manufacturing and Assembly</h1>
        <section className="videoCart">
          <main className={"slideLeft s05"}>
            <div className={"video--bloque--a"}></div>
            <LazyIframe src={"jjFBwV69JKc"} title={"Manufacturing and Assembly"} />
          </main>
          <aside className={"slideLeft s1"}>
            <div className="stepNavigation">
              <Link to="/training-days/step-5-1/#top" className={"stepNavigation__button--back "}>
                {" "}
                <span className={"stepNavigation__button--back--right"}> </span> Back{" "}
              </Link>
              <Link to="/training-days/step-5-3/#top" className={"stepNavigation__button--next"}>
                {" "}
                <span className={"stepNavigation__button--next--left"}> </span> Next{" "}
              </Link>
            </div>
            <p>Technical video about this profesional field</p>
            <a
              className={"pdf"}
              href={"/downloads/CERTIFICADO-PROFESIONALIDAD-FABRICACIÓN-MECÁNICA.pdf"}
              rel="noreferrer"
              target={"_blank"}
            >
              Certificate
            </a>
          </aside>
        </section>
      </div>
    </LayoutStep>
  );
};

export default Step52;
